<template>
  <div class="home">
    <div class="card">
      <div class="card-header">
        <strong>User information</strong>
      </div>
      <div class="card-body">
        <UserDetail></UserDetail>
      </div>
    </div>
  </div>
</template>

<script>
import UserDetail from "@/components/UserDetail.vue";


export default {
  components: {UserDetail},
}
</script>

<style>
</style>
